<div class="container-fluid">
  <app-header></app-header>
  <div class="row">
    <div class="col-md-12">
        <router-outlet></router-outlet>
    </div>
  </div>


<app-footer></app-footer>
</div>

